import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QrConfigTableService {
  constructor(private http:HttpClient) { }


  qrConfigTable(data:any){
    return this.http.post(environment.apiUrl + "qrCodeConfig/get/all" , data);
  }
}